import React from 'react';
import Col from 'react-bootstrap/Col';
import Slider from 'react-slick';
import properties from '../../../modules/ajio-util/properties';
import { getImageNameForGTMPromotion } from '../../../modules/ga/gtmLandingPageMethods';
import BannerWrapper from '../../BannerWrapper';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class NativeFeatureOverlapCarouselList extends React.Component {
  render() {
    const pagedetails = this.props.pagedetails;
    const bannerDetail = pagedetails.nativeFeatureOverlapCarouselListDetails;
    const widgetType = pagedetails.typeCode;
    const sectionName = this.props.componentTitle
      ? this.props.componentTitle
      : pagedetails.typeCode;

    if (bannerDetail === undefined) {
      return null;
    }
    var slickSettings = {
      dots: true,
      arrows: true,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 2000,
      swipe: false,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    const imgSecs = bannerDetail.map((data, i) => {
      const imageDetails = data.imageDetails;
      return (
        <div className="feature-overlap" key={i}>
          {data.imageDetails.map((image, j) => {
            let bannerImgUrl = '';
            bannerImgUrl =
              image.imageUrl.indexOf('?') == -1
                ? image.imageUrl
                : image.imageUrl.substr(0, image.imageUrl.indexOf('?'));
            if (image.imagePosition === 'heroBanner') {
              return (
                <div className="hero-image" key={j}>
                  <a
                    href={image.bannerUrlLink}
                    className="img-animate"
                    data-ga-event-category="bannerTap"
                    data-ga-event-action={`${sectionName}/${image.componentPosition}/${widgetType}`}
                    data-ga-event-label={`${bannerImgUrl}/${image.bannerPosition}`}
                    data-gtm-bnr-position={`${image.componentPosition}`}
                    data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(image.imageUrl) || ''}`}
                    data-gtm-bnr-id={`${image.uId || ''}`}
                  >
                    <img src={`${replaceWithJioCDN(image.imageUrl)}`} />
                  </a>
                </div>
              );
            }
            if (image.imagePosition !== 'heroBanner') {
              return (
                <div key={j} className="gallery-section">
                  <a
                    href={image.bannerUrlLink}
                    data-ga-event-category="bannerTap"
                    data-ga-event-action={`${sectionName}/${image.componentPosition}/${widgetType}`}
                    data-ga-event-label={`${bannerImgUrl}/${image.bannerPosition}`}
                    data-gtm-bnr-position={`${image.componentPosition}`}
                    data-gtm-bnr-imgname={`${getImageNameForGTMPromotion(image.imageUrl) || ''}`}
                    data-gtm-bnr-id={`${image.uId || ''}`}
                  >
                    <img src={`${replaceWithJioCDN(image.imageUrl)}`} className="img-animate" />
                  </a>
                </div>
              );
            }
          })}
        </div>
      );
    });

    let imageList;
    if (imgSecs.length > 1) {
      imageList = (
        <Slider {...slickSettings} ref="slick">
          {imgSecs}
        </Slider>
      );
    } else {
      imageList = imgSecs;
    }

    return (
      <div className="gallery-com feature-overlap">
        <div className="overlap-gallery">
          <Col xs={12}>{imageList}</Col>
        </div>
      </div>
    );
  }
}

export default BannerWrapper(NativeFeatureOverlapCarouselList);
